import {
  SET_MOBILE_DETAILS_VIEW,
  SET_HAS_SUBLEAGUES,
} from "../Actions/mobileActions";

const defaultState = {
  gameDetailsVisible: false,
  hasSubleagues: false,
};

export const mobileReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_MOBILE_DETAILS_VIEW:
      return {
        ...state,
        gameDetailsVisible: action.payload.gameDetailsVisible,
      };
    case SET_HAS_SUBLEAGUES:
      return {
        ...state,
        hasSubleagues: action.payload.hasSubleagues,
      };
    default:
      return state;
  }
};
